import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-panel px-4 py-8" data-id="element-76" data-mp="1lbisipaq7vqv">
      <div className="mx-auto max-w-2xl" data-id="element-77" data-mp="1l9frla81ci7d">
        <h2 id="faq-title" className="text-center font-head text-2xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-78" data-mp="1gdh0vfz8io3s">
          Frequently asked questions
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-79" data-mp="291mms620yj57">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <div key={item.q} className="overflow-hidden rounded-lg border border-white/10 bg-night" data-id="element-80" data-mp="240yulh227w9e" data-mpi={index}>
                <h3 data-id="element-81" data-mp="1z2dtzgiwbakf">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-[12px] font-semibold text-white sm:text-sm" data-id="element-82" data-mp="1z2x8sod91iu8">
                    {item.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-cta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-83" data-mp="pizatk21ig9i" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-white/10 px-3 py-2 text-[12px] leading-snug text-silver" data-id="element-84" data-mp="fjibrlhan0mi">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}